import {liftListItem, sinkListItem, splitListItem} from "prosemirror-schema-list";

import {isBlockActive} from "../../../utils/isBlockActive";
import {setListTypeOrWrapInList} from '../../../utils/setListTypeOrWrapInList';

import {schema} from "../../config/schema";

export const isNodeBulletList = isBlockActive(schema.nodes.list, {type: 'bullet'})
export const isNodeOrderedList = isBlockActive(schema.nodes.list, {type: 'ordered'})
export const isNodeChecklist = isBlockActive(schema.nodes.list, {type: 'checklist'})


export const setListTypeBullet = setListTypeOrWrapInList(schema.nodes.list, {
    type: 'bullet',
})
export const setListTypeOrdered = setListTypeOrWrapInList(schema.nodes.list, {
    type: 'ordered',
})
export const setListTypeChecklist = setListTypeOrWrapInList(schema.nodes.list, {
    type: 'checklist',
})


export const liftListItemCommand = liftListItem(schema.nodes.listItem)
export const sinkListItemCommand = sinkListItem(schema.nodes.listItem) // TODO: same list type
export const splitListItemCommand = splitListItem(schema.nodes.listItem)
